import { render, staticRenderFns } from "./ItemCreate.vue?vue&type=template&id=88f171bc"
import script from "../../../controllers/custom/item/item-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/item/item-create.js?vue&type=script&lang=js&external"
import style0 from "./ItemCreate.vue?vue&type=style&index=0&id=88f171bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports